import { Spinner } from '@/components/Spinner';
import { useStaticDataTypeLabelDetail } from './hooks/useStaticDataTypeLabelDetail';
import { ManageStaticDataTypeLabelView } from './ManageStaticDataTypeLabelView';

export const ManageStaticDataTypeLabelContainer = ({
  staticDataTypeId,
  staticDataLabelId,
}: {
  staticDataTypeId?: string;
  staticDataLabelId?: string;
}) => {
  const { staticDataLabel, isLoading } = useStaticDataTypeLabelDetail(staticDataLabelId);
  if (isLoading) return <Spinner />;
  return (
    <ManageStaticDataTypeLabelView
      staticDataTypeId={staticDataTypeId}
      staticDataLabelId={staticDataLabelId}
      staticDataLabel={staticDataLabel}
    />
  );
};
